<template lang="html">
  <transition name="fadeInSubtle">
    <div class="reset-screen">

      <div class="loader-wrapper">
        <div v-show="isLoading" class="loader"></div>
      </div>

      <div v-show="!isLoading" class="reset-wrapper">

        <router-link :to="{ name: 'login' }" class="return-back">
          <div class="arrow"></div>
          {{ $t('common.go_back')}}
        </router-link>

        <h2 class="header">{{ $t('login.reset_password') }}</h2>
        <div v-if="!emailSent">
          <hr />

          <p class="reset-info">{{ $t('login.reset_info') }}</p>

          <form class="form">
            <label class="form__label">
              <input
                type="email"
                class="form__credentials-input"
                v-model="credentials.email"
                :placeholder="$t('login.enter_email')"
                v-validate data-vv-rules="required|email"
                data-vv-delay="1000"
                name="email"

              >
            </label>

            <div class="form__error" v-if="error.message !== ''">
              <p class="form_error--message">{{ error.message }}</p>
            </div>

            <div class="form__error" v-show="errors.has('email')">
              {{ $t('errors.email_field') }}
            </div>

            <button  class="form__login-button btn" @click.stop.prevent="submit()">
              {{ $t('login.reset_password') }}
            </button>

          </form>
        </div>

        <div class="email-sent-wrapper" v-else>
          <hr />

          <span class="email-sent">{{ $t('login.email_sent') }}</span>
          <h4 class="email-address">{{ credentials.email }}</h4>
        </div>

      </div>

    </div>
  </transition>
</template>

<script>
export default {
  name: 'reset',
  data() {
    return {
      credentials: {
        email: '',
      },
      isLoading: false,
      error: {
        message: '',
      },
      emailSent: false,
    };
  },
  methods: {
    submit() {
      this.$validator.validateAll().then((success) => {
        if (success) {
          this.isLoading = true;
          this.$http.post(`${process.env.BACKEND_API_URL}api/password/email/${this.$i18n.locale}`, this.credentials).then((response) => {
            this.isLoading = false;
            if (response.body.status === 'email_sent') {
              this.emailSent = true;
            } else {
              this.error.message = this.$t('login.email_sent_error');
            }
          }).catch(() => {
            this.isLoading = false;
            this.error.message = this.$t('login.email_sent_error');
          });
        }
      }).catch(() => {
        // this.error.message = this.$t('login.email_sent_error');
      });
    },
  },
};
</script>

<style lang="scss">
@import '~styles/app.scss';

.reset-screen {

  .reset-wrapper {
    padding: 70px 60px;

    .form {
      position: relative;

      &__label {
        width: 100%;
        display: flex;
        max-width: unset;
      }

      &__error {
        margin: 10px 0;
        text-align: center;
        color: var(--brand-red);

        .form_error--message {
          font-weight: 900;
        }
      }
    }

    .email-sent-wrapper {
      text-align: center;


      .email-sent {
        position: relative;
        top: 40px;
        font-size: 12px;
        font-weight: 900;
      }

      .email-address {
        position: relative;
        top: 20px;
        color: var(--brand-orange);
        font-size: 28px;
      }

    }

    .return-back {
      position: relative;
      bottom: 47px;
      right: 16px;
      color: var(--brand-blue);
      font-weight: 900;
      transition: all 200ms ease-in-out;
      display: inline-block;
      margin: 0;
      padding: 0;
      left: -30px;

      .arrow {
        position: relative;
        background-image: url('~icons/arrow-2.svg');
        width: 19px;
        height: 19px;
        background-size: cover;
        transition: all 200ms ease-in-out;
        display: inline-block;
        margin: 1px;
        top: 6px;
      }

      &:hover {
        transition: all 200ms ease-in-out;
        color: var(--brand-orange);

        .arrow {
          background-size: contain;
          transition: all 200ms ease-in-out;
          transform: translateX(-7.5px) scale(1.50);
        }
      }
    }

    .header {
      font-weight: 400;
      padding: 0 0 5px 0;

      @media screen and (max-height: 740px) { /* was 650px */
        margin: 10px 0;
      }

    }

    .reset-info {
      font-size: 12px;
      margin: 35px 0 55px 0;
      padding: 0 10px;

      @media screen and (max-height: 740px) {
        margin: 10px 0;
      }

    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/login/PasswordReset.vue